// Mensajes de validación
const messages = {
  required: 'Este campo es requerido',
  email: 'Email inválido',
  emailMatch: 'Los emails no coinciden',
  minPassengers: 'Al menos un pasajero es requerido',
  hotelTransferRequired: 'Debe indicar si necesita traslado de hotel',
  invalidBirthDate: 'La fecha de nacimiento debe ser anterior al 2020',
  invalidPhone: 'Formato inválido. Use: +[código país] número (ej: +57 300 123 4567)',
  invalidArrivalDate: 'La fecha de llegada debe ser igual o mayor a la fecha actual',
  invalidDepartureDate: 'La fecha de salida debe ser mayor o igual a la fecha de llegada',
};

// Función helper para validar email
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validación para Step 1: Noche Adicional
const validateStep1 = (data) => {
  const errors = {};

  // includeAdditionalNight es boolean, siempre válido

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validación para Step 2: Datos de Pasajeros
const validateStep2 = (data) => {
  const errors = {};
  const passengersErrors = [];

  if (!data.passengers || data.passengers.length === 0) {
    errors.passengers = messages.minPassengers;
    return { isValid: false, errors };
  }

  data.passengers.forEach((passenger, index) => {
    const passengerErrors = {};

    if (!passenger.lastName || passenger.lastName.trim() === '') {
      passengerErrors.lastName = messages.required;
    }

    if (!passenger.firstName || passenger.firstName.trim() === '') {
      passengerErrors.firstName = messages.required;
    }

    if (!passenger.birthDate || passenger.birthDate.trim() === '') {
      passengerErrors.birthDate = messages.required;
    } else {
      // Validar que la fecha de nacimiento sea anterior al 2025
      const birthDate = new Date(passenger.birthDate);
      const maxDate = new Date('2020-01-01');
      if (birthDate >= maxDate) {
        passengerErrors.birthDate = messages.invalidBirthDate;
      }
    }

    if (!passenger.idType || passenger.idType.trim() === '') {
      passengerErrors.idType = messages.required;
    }

    if (!passenger.idNumber || passenger.idNumber.trim() === '') {
      passengerErrors.idNumber = messages.required;
    }

    if (!passenger.nationality || passenger.nationality.trim() === '') {
      passengerErrors.nationality = messages.required;
    }

    if (Object.keys(passengerErrors).length > 0) {
      passengersErrors[index] = passengerErrors;
    }
  });

  if (passengersErrors.length > 0) {
    errors.passengers = passengersErrors;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validación para Step 3: Datos de Contacto
const validateStep3 = (data) => {
  const errors = {};

  if (!data.email || data.email.trim() === '') {
    errors.email = messages.required;
  } else if (!isValidEmail(data.email)) {
    errors.email = messages.email;
  }

  if (!data.confirmEmail || data.confirmEmail.trim() === '') {
    errors.confirmEmail = messages.required;
  } else if (!isValidEmail(data.confirmEmail)) {
    errors.confirmEmail = messages.email;
  }

  // Validar que los emails coincidan
  if (data.email && data.confirmEmail && data.email !== data.confirmEmail) {
    errors.confirmEmail = messages.emailMatch;
  }

  if (!data.phone || data.phone.trim() === '') {
    errors.phone = messages.required;
  } else {
    // Validar formato internacional: +[código país] número
    // Acepta: +57 300 123 4567, +1 555 1234567, +34612345678, etc.
    const phoneRegex = /^\+\d{1,4}\s?\d{6,14}$/;
    if (!phoneRegex.test(data.phone.trim())) {
      errors.phone = messages.invalidPhone;
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validación para Step 4: Itinerario de Viaje
const validateStep4 = (data) => {
  const errors = {};

  // Validar fecha de llegada si está presente
  if (data.arrivalDate && data.arrivalDate.trim() !== '') {
    const arrivalDate = new Date(data.arrivalDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Resetear hora para comparar solo fechas

    if (arrivalDate < today) {
      errors.arrivalDate = messages.invalidArrivalDate;
    }
  }

  // Validar fecha de salida si está presente
  if (data.departureDate && data.departureDate.trim() !== '') {
    const departureDate = new Date(data.departureDate);

    // Si ambas fechas están presentes, validar que salida >= llegada
    if (data.arrivalDate && data.arrivalDate.trim() !== '') {
      const arrivalDate = new Date(data.arrivalDate);
      if (departureDate < arrivalDate) {
        errors.departureDate = messages.invalidDepartureDate;
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validación para Step 5: Traslado al Hotel
const validateStep5 = (data) => {
  const errors = {};

  if (!data.hotelTransfer) {
    errors.hotelTransfer = { needsTransfer: messages.hotelTransferRequired };
  } else {
    const hotelTransferErrors = {};

    if (!data.hotelTransfer.needsTransfer ||
        (data.hotelTransfer.needsTransfer !== 'SI' && data.hotelTransfer.needsTransfer !== 'NO')) {
      hotelTransferErrors.needsTransfer = messages.hotelTransferRequired;
    }

    if (Object.keys(hotelTransferErrors).length > 0) {
      errors.hotelTransfer = hotelTransferErrors;
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validación para Step 6: Contacto de Emergencia
const validateStep6 = (data) => {
  const errors = {};
  const emergencyContactsErrors = [];

  if (!data.emergencyContacts || data.emergencyContacts.length === 0) {
    errors.emergencyContacts = 'Al menos un contacto de emergencia es requerido';
    return { isValid: false, errors };
  }

  // Filtrar contactos que tienen al menos el nombre
  const filledContacts = data.emergencyContacts.filter(contact =>
    contact.name && contact.name.trim() !== ''
  );

  if (filledContacts.length === 0) {
    errors.emergencyContacts = 'Al menos un contacto de emergencia es requerido';
    return { isValid: false, errors };
  }

  // Validar que los contactos con nombre estén completos
  data.emergencyContacts.forEach((contact, index) => {
    if (!contact.name || contact.name.trim() === '') {
      return; // Skip empty contacts
    }

    const contactErrors = {};

    if (!contact.address || contact.address.trim() === '') {
      contactErrors.address = messages.required;
    }

    if (!contact.city || contact.city.trim() === '') {
      contactErrors.city = messages.required;
    }

    if (!contact.country || contact.country.trim() === '') {
      contactErrors.country = messages.required;
    }

    if (!contact.phone || contact.phone.trim() === '') {
      contactErrors.phone = messages.required;
    }

    if (!contact.relationship || contact.relationship.trim() === '') {
      contactErrors.relationship = messages.required;
    }

    if (Object.keys(contactErrors).length > 0) {
      emergencyContactsErrors[index] = contactErrors;
    }
  });

  if (emergencyContactsErrors.length > 0) {
    errors.emergencyContacts = emergencyContactsErrors;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Objeto con todas las funciones de validación por step
export const stepValidators = {
  1: validateStep1,
  2: validateStep2,
  3: validateStep3,
  4: validateStep4,
  5: validateStep5,
  6: validateStep6
};

// Función helper para extraer datos de un step específico
export const extractStepData = (formData, step) => {
  switch (step) {
    case 1:
      return {
        includeAdditionalNight: formData.includeAdditionalNight || false
      };
    case 2:
      return {
        passengers: formData.passengers || []
      };
    case 3:
      return {
        email: formData.email || '',
        confirmEmail: formData.confirmEmail || '',
        phone: formData.phone || ''
      };
    case 4:
      return {
        arrivalDate: formData.arrivalDate || '',
        arrivalAirlineFlight: formData.arrivalAirlineFlight || '',
        departureDate: formData.departureDate || '',
        departureAirlineFlight: formData.departureAirlineFlight || ''
      };
    case 5:
      return {
        hotelTransfer: formData.hotelTransfer || { needsTransfer: 'NO', numberOfTickets: '0' }
      };
    case 6:
      return {
        emergencyContacts: formData.emergencyContacts || []
      };
    default:
      return {};
  }
};

// Función para mapear tipos de identificación (form -> backend)
export const mapIdentificationType = (idType) => {
  switch (idType) {
    case 'cedula':
      return 'CEDULA';
    case 'pasaporte':
      return 'PASSPORT';
    case 'extranjeria':
      return 'TARJETA_IDENTIDAD';
    default:
      return 'CEDULA';
  }
};
